import React from 'react';
import Box from "@mui/material/Box/Box";

export function ThankYouPage() {
  return (
    <>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingBottom: '0'}}>
        <h1>Thank you for your purchase!</h1>
      </Box>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingTop: '0'}}>
          <p>We have received your order and will be processing it shortly</p>
      </Box>
    </>
  );
}